

import { BidiModule } from '@angular/cdk/bidi';
import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';

import { MwcBadgeSupComponent } from './badge-sup.component';
import { MwcBadgeComponent } from './badge.component';
import { MwcRibbonComponent } from './ribbon.component';

@NgModule({
  declarations: [MwcBadgeComponent, MwcBadgeSupComponent, MwcRibbonComponent],
  exports: [MwcBadgeComponent, MwcRibbonComponent],
  imports: [BidiModule, CommonModule, ObserversModule, MwcOutletModule, MwcNoAnimationModule]
})
export class MwcBadgeModule {}
